export default "__VITE_ASSET__BQykT3Kt__"